import React from 'react';
import { Helmet } from "react-helmet";
import Footer from './Footer';
import Select from 'react-dropdown-select';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
import 'antd/dist/antd.css';
// import Nothing_here from './Nothing_here';
import search from '../assets/images/search.png';
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { PROJECTNAME } from '../constants/custom_config';
import family_image from '../assets/images/family-image.svg';
import calendar from '../assets/images/icons/calendar.svg';
import gender from '../assets/images/icons/gender.svg';
import call from '../assets/images/icons/call.svg';
import message from '../assets/images/icons/message.svg';

import current_location from '../assets/images/current-location.png';

import map_marker from '../assets/images/map-marker.png';



import Headermain from './Headermain';
import Slidemenu from './Slidemenu';

const selectRelation = [
    { label: 'Spouse', value: 'Spouse' },
    { label: 'Child', value: 'Child' },
    { label: 'Parent', value: 'Parent' },
    { label: 'Grand Parent', value: 'Grand Parent' },
    { label: 'Sibling', value: 'Sibling' },
    { label: 'Friend', value: 'Friend' },
    { label: 'Relative', value: 'Relative' },
    { label: 'Neighbour', value: 'Neighbour' },
]


class Family_member extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        const menu = (
            <Menu
              items={[
                {
                  label: <div className="current-location-box">
                            <div className="current-location-title-area">
                                <div className="current-location-title-box">
                                    <p className="current-location-title">Current Location</p>
                                </div>
                            </div>
                            <div className="location-link-box">
                                <a href="" className="location-link">Detect Using GPS</a>
                            </div>
                        </div>
                ,
                  key: '0',
                },
                {
                  label: <div className="search-location-area">
                            <div className="search-location-box">
                                <input type="text" className="search-input-field common-input-field" placeholder="Search for location" />
                            </div>
                        </div>,
                  key: '1',
                }
              ]}
            />
          );

        function onChange(date, dateString) {
            console.log(date, dateString);
        }
        function disabledDate(current) {
            return current > moment().endOf('day');
        }
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Family Member</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="banner-dropdown-search-box-wrapper use-loaction-header profile-location-dropdown">
                                        <div className="banner-dropdown-search-area">
                                            <div className="banner-location-dropdown">
                                                <Dropdown overlay={menu} ClassName="location-dropdown" trigger={['click']} onClick={(e) => e.preventDefault()}>
                                                    <a onClick={(e) => e.preventDefault()}>
                                                    <Space>
                                                        Select Location
                                                        <DownOutlined />
                                                    </Space>
                                                    </a>
                                                </Dropdown>
                                            </div>
                                            <div className="banner-search-input-box" onClick={(e) => e.preventDefault()}>
                                                <span className="search-icon-box">
                                                    <img src={search} alt="" />
                                                </span>
                                                <input type="text" className="serach-input-field" placeholder="Search your Preferred Lab or Test" />
                                            </div>
                                        </div>
                                </div>
                                <Slidemenu prop={this.props} />
                                <div className="addresses family-members common-content content">
                                    <h3>Family Members</h3>
                                    <a href="" title="Add New Member" data-bs-toggle="modal" data-bs-target="#familyMember" className="add-address add-member">Add New Member</a>
                                    <div className="address-wrapper family-members-wrapper">
                                        <div className="address-info">
                                            <div className="address-name member-name">
                                                <h4>Anjali Gupta</h4>
                                                <span className="address-tag member-tag">spouse</span>
                                                <a href="" title="Edit" data-bs-toggle="modal" data-bs-target="#familyMember">Edit</a>
                                            </div>
                                            <div className="member-detail-wrapper">
                                                <ul className="member-detail-row">
                                                    <li className="member-detail-col">
                                                        <div className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={calendar} alt="Date" />
                                                            </div>
                                                            <span className="member-detail-text">24 Feb, 1988</span>
                                                        </div>
                                                    </li>
                                                    <li className="member-detail-col">
                                                        <div className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={gender} alt="Gender" />
                                                            </div>
                                                            <span className="member-detail-text">Female</span>
                                                        </div>
                                                    </li>
                                                    <li className="member-detail-col">
                                                        <a href="tel:+919595959595" className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={call} alt="Call" />
                                                            </div>
                                                            <span className="member-detail-text">+91 9595959595</span>
                                                        </a>
                                                    </li>
                                                    <li className="member-detail-col">
                                                        <a href="mailto:anjali.gupta@gmail.com" className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={message} alt="Mail" />
                                                            </div>
                                                            <span className="member-detail-text">anjali.gupta@gmail.com</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="address-info">
                                            <div className="address-name member-name">
                                                <h4>Shaurya Gupta</h4>
                                                <span className="address-tag member-tag">Child</span>
                                                <a href="" title="Edit" data-bs-toggle="modal" data-bs-target="#familyMember">Edit</a>
                                            </div>
                                            <div className="member-detail-wrapper">
                                                <ul className="member-detail-row">
                                                    <li className="member-detail-col">
                                                        <div className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={calendar} alt="Date" />
                                                            </div>
                                                            <span className="member-detail-text">24 Nov, 2010</span>
                                                        </div>
                                                    </li>
                                                    <li className="member-detail-col">
                                                        <div className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={gender} alt="Gender" />
                                                            </div>
                                                            <span className="member-detail-text">Male</span>
                                                        </div>
                                                    </li>
                                                    <li className="member-detail-col">
                                                        <a href="tel:+919797979797" className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={call} alt="Call" />
                                                            </div>
                                                            <span className="member-detail-text">+91 9797979797</span>
                                                        </a>
                                                    </li>
                                                    <li className="member-detail-col">
                                                        <a href="mailto:shaurya.gupta@gmail.com" className="member-detail-box">
                                                            <div className="img-box">
                                                                <img src={message} alt="Mail" />
                                                            </div>
                                                            <span className="member-detail-text">shaurya.gupta@gmail.com</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="address-info">
                                        </div>
                                    </div>


                                    {/* <Nothing_here wrapperClass="common-nothing-wrapper no-family-member-wrapper" imageAreaClass="image-area-box" imgSrc={family_image} descriptionClass="common-nothing-description" descriptionText="No Member added yet" btnClass="common-nothing-btn add-member-btn" btnText="+ Add New Member" modal="modal" modalTarget="#familyMember"/> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="edit_form edit_family_member_form modal fade" id="familyMember" tabindex="-1" aria-labelledby="familyMemberLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="familyMemberLabel">Edit Family Member</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <form id="address_form" className='popup_form' method="post">
                                    <div className="form-group">
                                        <label htmlFor="firstName" className="label">First Name</label>
                                        <div className="input-field-box">
                                            <input type="text" name="name" className="form-control" required="required" id="firstName"/>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="lastName" className="label">Last Name</label>
                                        <div className="input-field-box"></div>
                                        <input type="text" name="name" className="form-control" required="required" id="lastName"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="mobileNumber" className="label">Mobile Number</label>
                                        <div className="input-field-box">
                                            <span className="mobile-prefix">+91</span>
                                            <input type="number" name="name" className="form-control mobile-number-field" pattern="+94[7-9]{2}-[0-9]{3}-[0-9]{4}" required="required" id="mobileNumber"/>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email" className="label">Email Address</label>
                                        <div className="input-field-box">
                                            <input type="email" name="name" className="form-control" required="required" id="email"/>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="relation" className="label">Date of Birth</label>
                                        <div className="input-field-box">
                                            <Space direction="vertical" className="ant-space-custom">
                                                <DatePicker onChange={onChange} disabledDate={disabledDate} placement="bottomLeft" size="small" className="form-control date-picker-field"  dropdownClassName="date-picker-dropdown" format="DD MMMM, YYYY"/>
                                            </Space>
                                        </div>
                                    </div>
                                    <div className="form-group select-dropdown-box">
                                        <label htmlFor="relation" className="label">Relation</label>
                                        <div className="input-field-box">
                                            <Select className="form-control custom-select-dropdown" id="relation" options={selectRelation} onChange={(value) => console.log(value)} />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group radio">
                                        <label className="label">Gender</label>
                                        <div className="gender-radio-select">
                                            <label className="radio-btn">Male
                                                <input type="radio" name="radio" id="billing" />
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className="radio-btn">Female
                                                <input type="radio" name="radio" id="shipping" />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="footer-btns">
                                        <button className="form_btn save">Save</button>
                                        <button className="form_btn del">Delete</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer prop={this.props} />
            </>
        );
    }
};

export default Family_member;